export var source = "fragment UserClosedPopups on UserGQL {\n  closedPopups {\n    name\n    lastUpdate\n    count\n  }\n}";
export default source;